module.exports = "img/44.aed4d5.webp";